<h1 mat-dialog-title>Promena lozinke</h1>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-5">
      <p>Unesite korisničko ime:</p>
    </div>
    <div class="col-md-7">
      <input class = "input" [(ngModel)]="username">
    </div>
  </div>

</div>
<div>
  <button mat-button class="btn float-left" (click)="onNoClick()">Cancel</button>
  <button mat-button  class="btn btn-warning float-right" (click)="send()">Pošalji zahtev</button>
</div>